import { useQuery } from 'react-query'

import { fetchProjectDocument, listProjectDocuments } from '../projectDocuments'

export const useListProjectDocuments = (projectPublicId?: string) => {
  return useQuery(
    ['projectDocuments', projectPublicId],
    async () => {
      if (!projectPublicId) throw new Error('Missing params')
      return await listProjectDocuments(projectPublicId)
    },
    {
      enabled: !!projectPublicId,
      staleTime: 5 * 60 * 1000,
      refetchInterval: 10 * 60 * 1000,
      placeholderData: [],
    },
  )
}

export const useFetchProjectDocument = (
  projectPublicId?: string,
  documentId?: string | number | null,
) => {
  return useQuery(
    ['projectDocuments', projectPublicId, documentId],
    async () => {
      if (!projectPublicId || !documentId) throw new Error('Missing params')
      return await fetchProjectDocument(projectPublicId, documentId)
    },
    {
      enabled: !!projectPublicId && !!documentId,
      staleTime: 5 * 60 * 1000,
      refetchInterval: 10 * 60 * 1000,
    },
  )
}
